import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form280Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        studentDirectoryParticipation: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true')
            .nullable(),
    });
